<script setup lang="ts">
import {
	ref,
	computed,
} from 'vue';
import IconStar from '@zyro-inc/site-modules/components/icons/IconStar.vue';
import IconStarOutline from '@zyro-inc/site-modules/components/icons/IconStarOutline.vue';

const props = withDefaults(defineProps<{
	modelValue?: number;
	maxValue?: number;
	validationErrorMessages: string[];
	areErrorsShown: boolean;
}>(), {
	maxValue: 5,
});

const emit = defineEmits<{
	'update:model-value': [number];
}>();

const hoveredRating = ref<number>(0);
const currentRating = computed(() => hoveredRating.value || props.modelValue || 0);

const handleStarClick = (rating: number) => {
	emit('update:model-value', rating);
};

const handleStarHover = (rating: number) => {
	hoveredRating.value = rating;
};

const handleMouseLeave = () => {
	hoveredRating.value = 0;
};
</script>

<template>
	<div
		class="rating-picker"
		data-qa="productpage-createreviewmodal-ratingpicker-selectreviewrating"
		@mouseleave="handleMouseLeave"
	>
		<div class="rating-picker__stars">
			<button
				v-for="star in maxValue"
				:key="star"
				type="button"
				class="rating-picker__star"
				data-qa="productpage-createreviewmodal-ratingpicker-selectreviewrating-starbutton"
				@click="handleStarClick(star)"
				@mouseenter="handleStarHover(star)"
			>
				<IconStar
					v-if="star <= currentRating"
					:size="32"
					data-qa="productpage-createreviewmodal-ratingpicker-selectreviewrating-filled-star"
				/>
				<IconStarOutline
					v-else
					:size="32"
					data-qa="productpage-createreviewmodal-ratingpicker-selectreviewrating-outline-star"
				/>
			</button>
		</div>
		<div v-if="validationErrorMessages.length && areErrorsShown">
			<p
				v-for="message in validationErrorMessages"
				:key="message"
				class="rating-picker__error-message text-body-2"
			>
				{{ message }}
			</p>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.rating-picker {
	&__stars {
		display: flex;
		gap: 4px;
	}

	&__star {
		cursor: pointer;
		transition: color 0.2s ease;
  }

	&__error-message {
		color: var(--color-danger-dark);
		text-align: left;
	}
}
</style>
